import { Component, Input } from "@angular/core";
import { FileUploadStatus } from "./FileUploadStatus";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Strings } from "../../shared/tools/Strings";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { ProductsService } from "../../products/service/products.service";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";

@Component({
  selector: "app-file-selector",
  templateUrl: "./file-selector.component.html",
  styleUrls: ["./file-selector.component.scss"]
})
export class FileSelectorComponent {
  faExclamationCircle = faExclamationCircle;
  faCheck = faCheck;
  faInfoCircle = faInfoCircle;

  @Input() public title: string;
  @Input() public fileName: string;
  @Input() public postPath: string;
  @Input() public allowReplace: boolean;

  public replace: boolean;
  public file: File | null;
  public status: FileUploadStatus;

  constructor(
    public readonly httpClient: HttpClient,
    public readonly productsService: ProductsService,
  ) {
    this.file = null;
    this.status = FileUploadStatus.pending;
    this.replace = false;
  }

  public fileSelected(event: Event): void {
    const target = event.target;
    if (target == null) {
      return;
    }
    if (!(target instanceof HTMLInputElement)) {
      return;
    }

    if (target.files == null) {
      return;
    }

    this.file = target.files.item(0);
    this.status = FileUploadStatus.pending;
  }

  public async upload(): Promise<void> {
    try {
      this.status = FileUploadStatus.uploading;
      const result = await this.httpClient.post(
        this.postPath,
        this.file,
        {
          params: {
            replace: (this.allowReplace ? this.replace : false) ? "true" : "false",
          },
          headers: {
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        }
      ).toPromise();
      this.status = FileUploadStatus.success;
      await this.productsService.loadProducts();
    } catch (e) {
      this.status = FileUploadStatus.error;
      if (e instanceof HttpErrorResponse) {
        alert(e.message);
      } else if (e instanceof Error) {
        alert(e.message);
      } else {
        alert(Strings.unknownError);
      }
    }
  }

  public isLoading(): boolean {
    return this.status === FileUploadStatus.uploading;
  }

  public isError(): boolean {
    return this.status === FileUploadStatus.error;
  }

  public isSuccess(): boolean {
    return this.status === FileUploadStatus.success;
  }
}
